import { SolutionsSummarySideBar } from './components/SolutionsSummarySideBar';
import { ModuleNameToModuleRegistry } from '../../types/types';

const summarySideBars: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  solutions_survey_summary_side_bar: SolutionsSummarySideBar,
});

export default summarySideBars;
